var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"returnPage",on:{"click":_vm.returnHistory}},[_c('img',{attrs:{"src":require("../../assets/img/registrationLogin/returnPage_icon.png"),"alt":"返回上一页"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }